import {SimplePage} from "../../elements/Pages";
import React from "react";
import {useQuery} from "@tanstack/react-query";
import ListViewTable from "../../elements/tables/ListViewTable";
import {getUserMacAddresses, getUserMacAddressExcel} from "../../../api/organizational";
import env from "react-dotenv";
import {DownloadButton} from "../../elements/Buttons";
import {getFlextimeExcel} from "../../../api/staff";

const columns = [
    {
        accessorKey: "full_name",
        id: "full_name",
        header: "Name",
        enableColumnFilter: true,
        headerClassNames: "medium-filter",
        filterFn: "containsString",
    },
    ...env.SCHOOL === 'KPI' ? [
        {
            accessorKey: "plupu_status",
            id: "plupu_status",
            header: "Status",
            columnType: "plupu_rating",
            enableColumnFilter: true,
            headerClassNames: "narrow-filter",
        }] : [],
    {
        accessorKey: "user_type",
        id: "user_type",
        header: "Gruppe",
        enableColumnFilter: true,
        headerClassNames: "medium-filter",
        filterFn: "containsString",
    },
    {
        accessorKey: "mac_address",
        id: "mac_address",
        header: "MAC-Adresse (Notebook/iPad)",
        enableColumnFilter: false,
    },
    {
        accessorKey: "mac_address_phone",
        id: "mac_address_phone",
        header: "MAC-Adresse Handy",
        enableColumnFilter: false,
    },
    {
        accessorKey: "mac_address_games_console",
        id: "mac_address_games_console",
        header: "MAC-Adresse Spielekonsole",
        enableColumnFilter: false,
    },
];

export default function MacAddressList() {
    const {isLoading, isSuccess, data} = useQuery(
        ["user_mac_addresses"],
        getUserMacAddresses
    );

    return (
        <SimplePage title="MAC-Adressen">
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900">
                            MAC-Adressen
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <DownloadButton
                            apiFunction={getUserMacAddressExcel}
                            fileName={`MacAdressen.xls`}
                            label="Excel herunterladen"/>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
